import { useMemo } from "react";
import { useLocation } from "react-router-dom";

export function useUrlSegments(): string[] {
  const location = useLocation();
  return useMemo(() => {

    return location.pathname
      .replace(/(^\/)|(\/$)/g, "")
      .split("/")
      .filter(Boolean);
  }, [location.pathname]);
}
